import React from 'react'
import PageOverlay from '../../components/PageOverlay'
import Dashboard from '../../components/Dashboard'
import LazyProtectedRoute from '../LazyProtectedRoute'

export default {
	path:'/',
	element: (<LazyProtectedRoute component={<Dashboard />} />),
}
